import {} from '..';
export const isStepWithValue = (value) => {
    return value.size !== undefined && value.size !== null;
};
export const isStepWithMultiplier = (value) => {
    return value.multiplier !== undefined && value.multiplier !== null;
};
export const createResolvedTokensFromScale = (scale) => {
    const tokens = {};
    for (const [key, value] of Object.entries(scale.steps)) {
        if (key === 'base' && isStepWithValue(value)) {
            tokens[`${scale.prefix}-base`] = `${value.size}${value.unit ?? ''}`;
        }
        else if (isStepWithMultiplier(value)) {
            tokens[`${scale.prefix}-${key}`] = `${value.multiplier * scale.steps.base.size}${scale.steps.base.unit ?? ''}`;
        }
        else if (isStepWithValue(value)) {
            tokens[`${scale.prefix}-${key}`] = `${value.size}${value.unit ?? ''}`;
        }
        else {
            throw Error(`invalid scale entry ${value}`);
        }
    }
    return tokens;
};
export const createTokensFromScale = (scale) => {
    const tokens = {};
    for (const [key, value] of Object.entries(scale.steps)) {
        if (key === 'base' && isStepWithValue(value)) {
            tokens[`${scale.prefix}-base`] = `${value.size}${value.unit ?? ''}`;
        }
        else if (isStepWithMultiplier(value)) {
            tokens[`${scale.prefix}-${key}`] = `calc(${value.multiplier} * var(--${scale.prefix}-base))`;
        }
        else if (isStepWithValue(value)) {
            tokens[`${scale.prefix}-${key}`] = `${value.size}${value.unit ?? ''}`;
        }
        else {
            throw Error(`invalid scale entry ${value}`);
        }
    }
    return tokens;
};
